import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { initGA, logPageView } from './utils/analytics'; // 🔹 Importera Google Analytics

import Home from './pages/Home';
import AboutUmrah from './pages/AboutUmrah';
import Contact from './pages/Contact';
import UmrahPackage from './pages/UmrahPackage';
import FAQ from './pages/FAQ';
import InterestForm from './pages/InterestForm';

import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

// 🔹 Komponent som spårar sidvisningar vid route-ändringar
function AnalyticsListener() {
    const location = useLocation();
    useEffect(() => {
        logPageView();
    }, [location]);
    return null;
}

function App() {
    useEffect(() => {
        initGA(); // 🔹 Initiera Google Analytics när appen startar
    }, []);

    return (
        <Router>
            <AnalyticsListener /> {/* 🔹 Lyssnar på sidvisningar */}
            <ScrollToTop />
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about-umrah" element={<AboutUmrah />} />
                <Route path="/Boka" element={<Contact />} />
                <Route path="/umrah-package" element={<UmrahPackage />} />
                <Route path="/FAQ" element={<FAQ />} />
                <Route path="/intresseanmalan" element={<InterestForm />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
